import React, { useRef, useState, useCallback, useEffect } from "react";
import { MoveLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dropdown,
  Button,
  Spinner,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import DOMPurify from "dompurify";
import ErrorExtractor from "../common/error_extractor";
import CommonDropdown from "../common/common_dropDown";
import deleteIcon from "../../assets/svg/delete-po.svg";
import {
  submitTripCostAPI,
  updateTripCostAPI,
  getTripCostEditApi,
  getTripDetailApi,
  saveAttachmentApi,
} from "./trip-cost-api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { v4 as uuidv4 } from "uuid";
import MultiSelectDropdown from "../common/commonMultiDropDown";
import AsyncSelect from "react-select/async";
import CustomDateRangePicker from "../common/dateRangeCustom";
import { format } from "date-fns";
import CommonStaticDropdown from "../common/common_static_dropdown";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import totalAmtIc from "../../assets/svg/rupee.svg";
import fuelCostIc from "../../assets/svg/fuel-cost-ic.svg";
import fastagIc from "../../assets/svg/fastag-ic.svg";
import otherCostIc from "../../assets/svg/other-cost.svg";
import totalWeightIc from "../../assets/svg/total_weight.svg";
import Sidebar from "../common/Sidebar";
import upload from "../../assets/svg/upload.svg";
import attachment from "../../assets/png/attachment.png";
import download from "../../assets/svg/download.svg";
import closeAttachment from "../../assets/svg/close-red.svg";
import { Navbar } from "../common/Navbar";

export const TripCostCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};

  useEffect(() => {
    if (id != null) {
      getTripsCostEdit(id);
    }
  }, [id]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [isLoader, setIsLoader] = useState(false);
  const [milestoneOption, setMilestoneOption] = useState(null);
  const [tripIDOption, setTripIDOption] = useState(null);
  const [VINOption, setVINOption] = useState(null);
  const [tripDetails, setTripDetails] = useState({});
  const [vendorOption, setVendorOption] = useState(null);
  const [locationOption, setLocationOption] = useState(null);

  const [selectedTab, setSelectedTab] = useState("Fuel Cost");

  const [stopsList, setStopsList] = useState([]);

  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    const updatedData = stopsList.map((row) => ({
      ...row,
      selected: newSelectAll,
    }));
    setSelectAll(newSelectAll);
    setStopsList(updatedData);
  };

  const handleRowSelect = (index) => {
    const updatedData = [...stopsList];
    updatedData[index].selected = !updatedData[index].selected;
    setStopsList(updatedData);
    setSelectAll(updatedData.every((row) => row.selected));
  };

  const [errorMsg, setErrorMsg] = useState({
    milestone_id: "",
    location_id: "",
    trip_id: "",
    vendor_id: "",
    stops: "",
  });

  const [fuelList, setFuelList] = useState([]);
  const [fastagList, setFastagList] = useState([]);
  const [otherCostList, setOtherCostList] = useState([]);

  const [groupedError, setGroupedError] = useState({});
  const [removedFuelList, setRemovedFuelList] = useState([]);
  const [removedFastagList, setRemovedFastagList] = useState([]);
  const [removedOtherCostList, setRemovedOtherCostList] = useState([]);

  const fileInputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [attachmentList, setAttachmentList] = useState([]);
  const [removedAttachmentList, setRemovedAttachmentList] = useState([]);

  // const [activeBtn, setActiveBtn] = useState("details");
  const handleInputFile = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      /* const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl); */
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result; // this will be the byte code (base64String)
        /*  console.log("Base64 String:", base64String.toString());
         saveAttachment(await reader.result); */
        console.log("3..........");
        setAttachmentList([
          ...attachmentList,
          {
            name: file.name,
            base64: base64String,
            size: formatBytes(file.size),
          },
        ]);
      };
      reader.readAsDataURL(file);
    }
  };
  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const file = event.dataTransfer.files[0];
    if (file) {
      /* const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl); */
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result; // this will be the byte code (base64String)
        /*  console.log("Base64 String:", base64String.toString());
           saveAttachment(await reader.result); */
        setAttachmentList([
          ...attachmentList,
          {
            name: file.name,
            base64: base64String,
            size: formatBytes(file.size),
          },
        ]);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleDelete = () => {
    setImage(null);
    fileInputRef.current.value = "";
  };

  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };

  const getErrorMsg = (index, field) => {
    if (field === "contact_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].contact_id != null) {
          return (
            groupedError[index].contact_id[0]?.replace(
              `contacts.${index}.contact_id`,
              "contact"
            ) ?? ""
          );
        }
      }
    }
    if (field === "mobile_number") {
      if (groupedError[index] != null) {
        if (groupedError[index].mobile_number != null) {
          return (
            groupedError[index].mobile_number[0]?.replace(
              `contacts.${index}.mobile_number`,
              "mobile_number"
            ) ?? ""
          );
        }
      }
    }
    if (field === "start_date") {
      if (groupedError[index] != null) {
        if (groupedError[index].start_date != null) {
          return (
            groupedError[index].start_date[0]?.replace(
              `contacts.${index}.start_date`,
              "start date"
            ) ?? ""
          );
        }
      }
    }

    if (field === "end_date") {
      if (groupedError[index] != null) {
        if (groupedError[index].end_date != null) {
          return (
            groupedError[index].end_date[0]?.replace(
              `contacts.${index}.end_date`,
              "end date"
            ) ?? ""
          );
        }
      }
    }

    if (field === "quantity") {
      if (groupedError[index] != null) {
        if (groupedError[index].quantity != null) {
          return (
            groupedError[index].quantity[0]?.replace(
              `products.${index}.quantity`,
              "quantity"
            ) ?? ""
          );
        }
      }
    }

    if (field === "price") {
      if (groupedError[index] != null) {
        if (groupedError[index].price != null) {
          return (
            groupedError[index].price[0]?.replace(
              `products.${index}.price`,
              "price"
            ) ?? ""
          );
        }
      }
    }

    return "";
  };

  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();

    const updatedFuelData = fuelList
      .filter((item) => item.location !== null)
      .map((item) => ({
        id: item.id ?? 0,
        location_id: item.location != null ? item.location.value : "",
        fuelbank: item.fuelbank,
        quantity: item.quantity,
        unit_price: item.unit_price,
        totalprice: item.totalprice,
      }));

    const updatedFastagData = fastagList
      .filter((item) => item.location !== null)
      .map((item) => ({
        id: item.id ?? 0,
        location_id: item.location != null ? item.location.value : "",
        amount: item.amount,
      }));

    try {
      const preSanitizeData = {
        trip_id: tripIDOption != null ? tripIDOption.value : "",
        total_cost: 0,
        fuel_costs: updatedFuelData,
        fasttag_cost: updatedFastagData,
        other_cost: otherCostList,
        removed_attachments: removedAttachmentList,
        removed_fuels: removedFuelList,
        removed_fast_tags: removedFastagList,
        removed_other_costs: removedOtherCostList,
      };

      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (
          typeof value === "boolean" ||
          typeof value === "number" ||
          Array.isArray(value)
        ) {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitTripCostAPI(sanitizedData);
      } else {
        response = await updateTripCostAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        /* const errorvalue = extractor.extractErrors(response.data.error, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue); */
        new Promise((resolve, reject) => {
          const validationTemp = {
            trip_id: "",
            fuel_costs: "",
            fasttag_cost: "",
            other_cost: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();

        if (attachmentList.length === 0) {
          navigate(-1);
        } else {
          saveAttachment(response.data.id);
        }
      } else {
        new Promise((resolve, reject) => {
          const validationTemp = {
            trip_id: "",
            fuel_costs: "",
            fasttag_cost: "",
            other_cost: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (
        err.response &&
        err.response.status === 400 &&
        err.response.data.error
      ) {
        new Promise((resolve, reject) => {
          const groupedErrorTemp = {};
          Object.entries(err.response.data.error).forEach(([key, value]) => {
            // match tickets.index.field
            const match = key.match(/^products\.(\d+)\.(.+)$/);

            if (match) {
              const index = match[1]; // e.g. "0"
              const field = match[2]; // e.g. "closing_date"

              if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
              groupedErrorTemp[index][field] = value;
            }
          });
          setGroupedError(groupedErrorTemp);
        });
        new Promise((resolve, reject) => {
          const validationTemp = {
            milestone_id: "",
            location_id: "",
            vehicle_id: "",
            vendor_id: "",
            stops: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      }
    } finally {
      setIsLoader(false);
    }
  };

  const saveAttachment = async (parentId) => {
    console.log("saveAttachment called");
    try {
      const data = {
        attachments: attachmentList.map((item) => item.base64),
      };
      const response = await saveAttachmentApi(parentId, data);
      if (response.data.success === true) {
        navigate(-1);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  };

  const getTripsCostEdit = async (id) => {
    try {
      const response = await getTripCostEditApi(id);

      if (response.data.success === true) {
        const tripDetail = response.data.trip_cost ?? {};
        setTripIDOption({
          value: tripDetail.trip_id,
          label: tripDetail.trip_code,
        });
        getTripDetails(tripDetail.trip_id);
        /* setMilestoneOption({
          value: tripDetail.milestone_id,
          label: tripDetail.mile_stone,
        });
        setLocationOption({
          value: tripDetail.location_id,
          label: tripDetail.location,
        });
        setVINOption({ value: tripDetail.vehicle_id, label: tripDetail.vin });
         setVendorOption({
          value: tripDetail.vendor_id,
          label: tripDetail.vendor,
        });
        setTripDetails({
          vehicle_type: tripDetail.vehicle_type,
          license_plate: tripDetail.license_plate,
        }); */

        setFuelList(
          tripDetail.fual_cost?.map((item) => ({
            id: item.id,
            fuelbank: item.fuelbank,
            location: { label: item.location, value: item.location_id },
            quantity: item.quentity,
            unit_price: item.unit_price,
            totalprice: item.totalprice,
          }))
        );
        setFastagList(
          tripDetail.fast_tag_cost?.map((item) => ({
            id: item.id,
            location: { label: item.location, value: item.location_id },
            amount: item.amount,
          }))
        );
        setOtherCostList(tripDetail.other_cost ?? []);
        setAttachmentURLList(tripDetail.attachments ?? []);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getTripDetails = async (id) => {
    const response = await getTripDetailApi(id);

    if (response.data.success === true) {
      setTripDetails(response.data.Trip ?? {});
    }
  };

  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const handleDateChange = ({ start, end }) => {
    setStartDate(start);
    setEndDate(end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };

  return (
    <div className="d-flex ">
      <Sidebar currentfile="Trip Cost" />
      <div
        className="rounded-4 flex-grow-1  "
        style={{ width: "calc(100vw - 80px)" }}
      >
        <Navbar pageTitle="Trip Cost" />
        <div
          className="scroll-hidden"
          style={{ background: "#F5F8FA", height: "calc(100vh - 56px)" }}
        >
          <div className="px-2 d-flex align-items-center justify-content-between">
            <div className="d-flex gap-3 my-3">
              <MoveLeft
                className="cursor-pointer"
                onClick={() => {
                  navigate(-1);
                }}
              />
              <p className="fw-semibold m-0">New trip cost</p>
            </div>
            <div className="d-flex gap-3">
              <Button
                className="cursor-pointer bg-white rounded-pill px-4 py-2  btn-border-grey fs-15 fw-500"
                style={{ border: "1px solid #D4DDE7", color: "#212129" }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
              <Button
                className={`cursor-pointer dark-purple-btn ${
                  isLoader ? "disabled-btn" : ""
                } rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                onClick={() => {
                  submitForm();
                }}
                style={{ minWidth: "100px" }}
              >
                {isLoader ? (
                  <Spinner animation="border" size="sm" />
                ) : id != null ? (
                  "Update"
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </div>
          <div className="col-12 px-2">
            <div className="row mb-2 mx-0">
              <div className="col-12 col-md-6 pe-0 ">
                <div className="bg-white rounded-4 d-flex flex-column align-items-start px-2 py-2">
                  <div className="fs-14 fw-700" style={{ color: "#28303F" }}>
                    Trip cost details
                  </div>

                  <div className="col-12">
                    <div className="row">
                      <div className="mt-2 col-12 col-lg-6  d-flex flex-column align-items-start">
                        <div
                          className="form-label fs-12 fw-400 my-0 mb-1"
                          style={{ color: "#28303F" }}
                        >
                          Trip ID<span className="text-danger">*</span>
                        </div>
                        <div className="w-100">
                          <CommonDropdown
                            apiUrl={`${apiUrl}trips/autosuggestion`}
                            placeholder="Select"
                            value={tripIDOption}
                            onSelect={(item) => {
                              setTripIDOption(item);
                              getTripDetails(item.value);
                            }}
                          />
                        </div>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "6px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.trip_id}
                        </span>
                      </div>
                      <div className="mt-2 col-12 col-lg-6  d-flex flex-column align-items-start  ps-0">
                        <div
                          className="form-label fs-12 fw-400 my-0 mb-1"
                          style={{ color: "#28303F" }}
                        >
                          Milestone
                        </div>

                        <div
                          className="w-100 rounded-3 px-2 d-flex align-items-center justify-content-start"
                          style={{ height: "40px", background: "#F8F8F8" }}
                        >
                          {" "}
                          <span
                            className="fs-14 fw-300 "
                            style={{ color: "#8790A1" }}
                          >
                            {tripDetails.milestone}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-2 col-12  d-flex flex-column align-items-start">
                    <div
                      className="form-label fs-12 fw-400 my-0 mb-1"
                      style={{ color: "#28303F" }}
                    >
                      Location
                    </div>
                    <div
                      className="w-100 rounded-3 px-2 d-flex align-items-center justify-content-start"
                      style={{ height: "40px", background: "#F8F8F8" }}
                    >
                      {" "}
                      <span
                        className="fs-14 fw-300 "
                        style={{ color: "#8790A1" }}
                      >
                        {tripDetails.location}{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 pe-0">
                <div className="bg-white rounded-4 d-flex flex-column align-items-start px-2 py-2">
                  <div className="fs-14 fw-700" style={{ color: "#28303F" }}>
                    Vehicle details
                  </div>

                  <div className="col-12">
                    <div className="row">
                      <div className="mt-2 col-12 col-lg-6  d-flex flex-column align-items-start">
                        <div
                          className="form-label fs-12 fw-400 my-0 mb-1"
                          style={{ color: "#28303F" }}
                        >
                          VIN
                        </div>
                        <div
                          className="w-100 rounded-3 px-2 d-flex align-items-center justify-content-start"
                          style={{ height: "40px", background: "#F8F8F8" }}
                        >
                          {" "}
                          <span
                            className="fs-14 fw-300 "
                            style={{ color: "#8790A1" }}
                          >
                            {tripDetails.vin}{" "}
                          </span>
                        </div>
                      </div>
                      <div className="mt-2 col-12 col-lg-6  d-flex flex-column align-items-start  ps-0">
                        <div
                          className="form-label fs-12 fw-400 my-0 mb-1"
                          style={{ color: "#28303F" }}
                        >
                          License Plate
                        </div>

                        <div
                          className="w-100 rounded-3 px-2 d-flex align-items-center justify-content-start"
                          style={{ height: "40px", background: "#F8F8F8" }}
                        >
                          {" "}
                          <span
                            className="fs-14 fw-300 "
                            style={{ color: "#8790A1" }}
                          >
                            {tripDetails.license_plate}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="row">
                      <div className="mt-2 col-12 col-lg-6  d-flex flex-column align-items-start">
                        <div
                          className="form-label fs-12 fw-400 my-0 mb-1"
                          style={{ color: "#28303F" }}
                        >
                          Vehicle Type
                        </div>
                        <div
                          className="w-100 rounded-3 px-2 d-flex align-items-center justify-content-start"
                          style={{ height: "40px", background: "#F8F8F8" }}
                        >
                          {" "}
                          <span
                            className="fs-14 fw-300 "
                            style={{ color: "#8790A1" }}
                          >
                            {tripDetails.vehicle_name}
                          </span>
                        </div>
                      </div>
                      <div className="mt-2 col-12 col-lg-6  d-flex flex-column align-items-start ps-0">
                        <div
                          className="form-label fs-12 fw-400 my-0 mb-1"
                          style={{ color: "#28303F" }}
                        >
                          Vendor
                        </div>
                        <div
                          className="w-100 rounded-3 px-2 d-flex align-items-center justify-content-start"
                          style={{ height: "40px", background: "#F8F8F8" }}
                        >
                          {" "}
                          <span
                            className="fs-14 fw-300 "
                            style={{ color: "#8790A1" }}
                          >
                            {tripDetails.vendor_name}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="m-2 bg-white rounded-4 p-3">
              <div className="d-flex align-items-center justify-content-start gap-2">
                <div
                  className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#FFEEEE" }}
                >
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      background: "#FF4444",
                      borderRadius: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img src={totalAmtIc} alt="total cost" />
                  </div>
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Total Cost
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {fuelList.reduce(
                        (sum, item) => sum + Number(item.totalprice),
                        0
                      ) +
                        fastagList.reduce(
                          (sum, item) => sum + Number(item.amount),
                          0
                        ) +
                        otherCostList.reduce(
                          (sum, item) => sum + Number(item.cost),
                          0
                        )}
                    </div>
                  </div>
                </div>
                <div
                  className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#F2F2FF" }}
                >
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      background: "#454CF2",
                      borderRadius: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img src={fuelCostIc} alt="fuelCostIc" />
                  </div>
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Fuel Cost
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {fuelList.reduce(
                        (sum, item) => sum + Number(item.totalprice),
                        0
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#E0FFED" }}
                >
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      background: "#2C8C53",
                      borderRadius: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img src={fastagIc} alt="fastagIc" />
                  </div>
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Fastag Cost
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {fastagList.reduce(
                        (sum, item) => sum + Number(item.amount),
                        0
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#FFFAE8" }}
                >
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      background: "#FDCA01",
                      borderRadius: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img src={otherCostIc} alt="otherCostIc" />
                  </div>
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Other Cost
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {otherCostList.reduce(
                        (sum, item) => sum + Number(item.cost),
                        0
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-12 ">
                  <div className="row">
                    <div className="w-100 mb-1  d-flex align-items-center justify-content-start gap-2">
                      <div
                        className={`cursor-pointer d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                          selectedTab === "Fuel Cost"
                            ? "fw-500 active-bottom-bar "
                            : " fw-400"
                        } `}
                        style={{
                          height: "32px",
                          width: "110px",
                          color:
                            selectedTab === "Fuel Cost" ? "#FFFFFF" : "#172B4D",
                          background:
                            selectedTab === "Fuel Cost" ? "#3469E7" : "#F5F5F5",
                        }}
                        onClick={() => {
                          setSelectedTab("Fuel Cost");
                        }}
                      >
                        Fuel Cost
                      </div>
                      <div
                        className={`cursor-pointer d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                          selectedTab === "Fastag Cost"
                            ? "fw-500 active-bottom-bar "
                            : " fw-400"
                        } `}
                        style={{
                          height: "32px",
                          minWidth: "110px",
                          color:
                            selectedTab === "Fastag Cost"
                              ? "#FFFFFF"
                              : "#172B4D",
                          background:
                            selectedTab === "Fastag Cost"
                              ? "#3469E7"
                              : "#F5F5F5",
                        }}
                        onClick={() => {
                          setSelectedTab("Fastag Cost");
                        }}
                      >
                        Fastag Cost
                      </div>

                      <div
                        className={`cursor-pointer d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                          selectedTab === "Other Cost"
                            ? "fw-500 active-bottom-bar "
                            : " fw-400"
                        } `}
                        style={{
                          height: "32px",
                          minWidth: "110px",
                          color:
                            selectedTab === "Other Cost"
                              ? "#FFFFFF"
                              : "#172B4D",
                          background:
                            selectedTab === "Other Cost"
                              ? "#3469E7"
                              : "#F5F5F5",
                        }}
                        onClick={() => {
                          setSelectedTab("Other Cost");
                        }}
                      >
                        Other Cost
                      </div>
                    </div>

                    {selectedTab === "Fuel Cost" && (
                      <>
                        <div style={{ overflowY: "visible" }}>
                          <div className="mt-2 sticky-table-wrapper ">
                            <table
                              className="stop-table"
                              border="1"
                              cellPadding="10"
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                                border: "1px solid #EBEBEB",
                              }}
                            >
                              <thead
                                style={{
                                  height: "48px",
                                  /*  backgroundColor: "#F2F2F2", // ✅ Green background */
                                  color: "#8790A1", // ✅ White text
                                  fontSize: "11px", // ✅ Font size
                                  fontWeight: "400",
                                  textAlign: "left",
                                }}
                              >
                                <tr>
                                  <th className="ps-2">FUEL STATION</th>
                                  <th className="ps-2">LOCATION</th>
                                  <th className="ps-2">QUANTITY</th>
                                  <th className="ps-2">PRICE PER LITER</th>
                                  <th className="ps-2">TOTAL PRICE</th>
                                  <th className="ps-2"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {fuelList.map((row, index1) => (
                                  <tr
                                    key={row.id}
                                    style={{
                                      height: "60px",
                                      position: "relative",
                                      overflow: "visible",
                                    }}
                                  >
                                    <td
                                      className="px-2 py-1"
                                      style={{
                                        position: "relative",
                                        overflow: "visible",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        className="form-control rounded-3 vendor-form-input"
                                        id={`mobile` + index1}
                                        placeholder="Enter here"
                                        value={row.fuelbank}
                                        onChange={(e) => {
                                          const updatedFuelList = [...fuelList];
                                          updatedFuelList[index1] = {
                                            ...updatedFuelList[index1],
                                            fuelbank: e.target.value,
                                          };
                                          setFuelList(updatedFuelList);
                                        }}
                                        style={{
                                          borderColor:
                                            getErrorMsg(index1, "fuelbank") !==
                                            ""
                                              ? "red"
                                              : "#EBEBEB",
                                        }}
                                      />{" "}
                                      <span className="fs-12 fw-400 cardTextRed">
                                        {getErrorMsg(index1, "fuelbank")}
                                      </span>
                                    </td>
                                    <td className="px-2 py-1">
                                      <div
                                        className="pe-3 py-1"
                                        style={{ width: "200px" }}
                                      >
                                        {" "}
                                        <CommonDropdown
                                          apiUrl={`${apiUrl}get_locations`}
                                          placeholder="Select"
                                          value={row.location}
                                          onSelect={(item) => {
                                            fuelList[index1]["location"] = item;
                                            setFuelList(fuelList);
                                          }}
                                        />
                                        <span className="fs-12 fw-400 cardTextRed">
                                          {getErrorMsg(index1, "location_id")}
                                        </span>
                                      </div>
                                    </td>

                                    <td className="px-2 py-1">
                                      <input
                                        type="text"
                                        className="form-control rounded-3 vendor-form-input"
                                        id={`quantity` + index1}
                                        placeholder="Enter here"
                                        value={row.quantity}
                                        onChange={(e) => {
                                          const tempDelivery = [...fuelList];
                                          tempDelivery[index1]["quantity"] =
                                            e.target.value
                                              .replace(/[^0-9.]/g, "")
                                              .replace(/(\..*)\./g, "$1");
                                          tempDelivery[index1]["totalprice"] = (
                                            Number(
                                              e.target.value
                                                .replace(/[^0-9.]/g, "")
                                                .replace(/(\..*)\./g, "$1") ?? 0
                                            ) *
                                            Number(
                                              tempDelivery[index1][
                                                "unit_price"
                                              ] ?? 0
                                            )
                                          ).toFixed(2);
                                          setFuelList(tempDelivery);
                                        }}
                                        style={{
                                          borderColor:
                                            getErrorMsg(index1, "quantity") !==
                                            ""
                                              ? "red"
                                              : "#EBEBEB",
                                        }}
                                      />{" "}
                                      <span className="fs-12 fw-400 cardTextRed">
                                        {getErrorMsg(index1, "quantity")}
                                      </span>
                                    </td>

                                    <td className="px-2 py-1">
                                      <input
                                        type="text"
                                        className="form-control rounded-3 vendor-form-input"
                                        id={`unit_price` + index1}
                                        placeholder="Enter here"
                                        value={row.unit_price}
                                        onChange={(e) => {
                                          const tempDelivery = [...fuelList];
                                          tempDelivery[index1]["unit_price"] =
                                            e.target.value
                                              .replace(/[^0-9.]/g, "")
                                              .replace(/(\..*)\./g, "$1");
                                          tempDelivery[index1]["totalprice"] = (
                                            parseFloat(
                                              tempDelivery[index1][
                                                "quantity"
                                              ] ?? 0
                                            ) *
                                            parseFloat(
                                              e.target.value
                                                .replace(/[^0-9.]/g, "")
                                                .replace(/(\..*)\./g, "$1") ?? 0
                                            )
                                          ).toFixed(2);
                                          setFuelList(tempDelivery);
                                        }}
                                        style={{
                                          borderColor:
                                            getErrorMsg(
                                              index1,
                                              "unit_price"
                                            ) !== ""
                                              ? "red"
                                              : "#EBEBEB",
                                        }}
                                      />{" "}
                                      <span className="fs-12 fw-400 cardTextRed">
                                        {getErrorMsg(index1, "unit_price")}
                                      </span>
                                    </td>
                                    <td className="px-2 py-1">
                                      <input
                                        type="text"
                                        className="form-control rounded-3 vendor-form-input"
                                        id={`totalprice` + index1}
                                        value={row.totalprice}
                                        readOnly={true}
                                      />
                                    </td>

                                    <td>
                                      <div
                                        style={{
                                          cursor: "pointer",
                                          marginTop: "14px",
                                        }}
                                        onClick={() => {
                                          if (
                                            row.id !== null &&
                                            row.id !== ""
                                          ) {
                                            setRemovedFuelList([
                                              ...removedFuelList,
                                              row.id,
                                            ]);
                                          }
                                          const tempFuelList = [...fuelList];
                                          tempFuelList.splice(index1, 1);
                                          setFuelList(tempFuelList);
                                        }}
                                        className="mx-2 ps-2 d-flex align-items-center justify-content-center "
                                      >
                                        <img src={deleteIcon} alt="delete" />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-xl-12 mt-2">
                          <Button
                            className={`cursor-pointer border-0 rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                            onClick={() => {
                              setFuelList([
                                ...fuelList,
                                {
                                  id: "",
                                  fuelbank: "",
                                  location: null,
                                  quantity: "",
                                  unit_price: "",
                                  totalprice: "",
                                },
                              ]);
                            }}
                            style={{
                              minWidth: "100px",
                              background: "#E6E4FF",
                              color: "#212129",
                              fontWeight: "600",
                              fontSize: "13px",
                            }}
                          >
                            Add fuel cost
                          </Button>
                        </div>
                      </>
                    )}

                    {selectedTab === "Fastag Cost" && (
                      <>
                        <div style={{ overflowY: "visible" }}>
                          <div className="mt-2 sticky-table-wrapper ">
                            <table
                              className="stop-table"
                              border="1"
                              cellPadding="10"
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                                border: "1px solid #EBEBEB",
                              }}
                            >
                              <thead
                                style={{
                                  height: "48px",
                                  /*  backgroundColor: "#F2F2F2", // ✅ Green background */
                                  color: "#8790A1", // ✅ White text
                                  fontSize: "11px", // ✅ Font size
                                  fontWeight: "400",
                                  textAlign: "left",
                                }}
                              >
                                <tr>
                                  <th className="ps-2">LOCATION</th>
                                  <th className="ps-2">AMOUNT</th>
                                  <th className="ps-2"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {fastagList.map((row, index1) => (
                                  <tr
                                    key={row.id}
                                    style={{
                                      height: "60px",
                                      position: "relative",
                                      overflow: "visible",
                                    }}
                                  >
                                    <td className="px-2 py-1">
                                      <div
                                        className="pe-3 py-1"
                                        style={{ width: "200px" }}
                                      >
                                        {" "}
                                        <CommonDropdown
                                          apiUrl={`${apiUrl}get_locations`}
                                          placeholder="Select"
                                          value={row.location}
                                          onSelect={(item) => {
                                            fastagList[index1]["location"] =
                                              item;
                                            setFastagList(fastagList);
                                          }}
                                        />
                                        <span className="fs-12 fw-400 cardTextRed">
                                          {getErrorMsg(index1, "location_id")}
                                        </span>
                                      </div>
                                    </td>

                                    <td className="px-2 py-1">
                                      <input
                                        type="text"
                                        className="form-control rounded-3 vendor-form-input"
                                        id={`amount` + index1}
                                        placeholder="Enter here"
                                        value={row.amount}
                                        onChange={(e) => {
                                          const tempFastag = [...fastagList];
                                          tempFastag[index1]["amount"] =
                                            e.target.value
                                              .replace(/[^0-9.]/g, "")
                                              .replace(/(\..*)\./g, "$1");

                                          setFastagList(tempFastag);
                                        }}
                                        style={{
                                          borderColor:
                                            getErrorMsg(index1, "amount") !== ""
                                              ? "red"
                                              : "#EBEBEB",
                                        }}
                                      />{" "}
                                      <span className="fs-12 fw-400 cardTextRed">
                                        {getErrorMsg(index1, "amount")}
                                      </span>
                                    </td>

                                    <td>
                                      <div
                                        style={{
                                          cursor: "pointer",
                                          marginTop: "14px",
                                        }}
                                        onClick={() => {
                                          if (
                                            row.id !== null &&
                                            row.id !== ""
                                          ) {
                                            setRemovedFastagList([
                                              ...removedFastagList,
                                              row.id,
                                            ]);
                                          }
                                          const tempFastagList = [
                                            ...fastagList,
                                          ];
                                          tempFastagList.splice(index1, 1);
                                          setFastagList(tempFastagList);
                                        }}
                                        className="mx-2 ps-2 d-flex align-items-center justify-content-center "
                                      >
                                        <img src={deleteIcon} alt="delete" />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-xl-12 mt-2">
                          <Button
                            className={`cursor-pointer border-0 rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                            onClick={() => {
                              setFastagList([
                                ...fastagList,
                                {
                                  id: "",
                                  location: null,
                                  amount: "",
                                },
                              ]);
                            }}
                            style={{
                              minWidth: "100px",
                              background: "#E6E4FF",
                              color: "#212129",
                              fontWeight: "600",
                              fontSize: "13px",
                            }}
                          >
                            Add fastag cost
                          </Button>
                        </div>
                      </>
                    )}

                    {selectedTab === "Other Cost" && (
                      <>
                        <div style={{ overflowY: "visible" }}>
                          <div className="mt-2 sticky-table-wrapper ">
                            <table
                              className="stop-table"
                              border="1"
                              cellPadding="10"
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                                border: "1px solid #EBEBEB",
                              }}
                            >
                              <thead
                                style={{
                                  height: "48px",
                                  /*  backgroundColor: "#F2F2F2", // ✅ Green background */
                                  color: "#8790A1", // ✅ White text
                                  fontSize: "11px", // ✅ Font size
                                  fontWeight: "400",
                                  textAlign: "left",
                                }}
                              >
                                <tr>
                                  <th className="ps-2">DESCRIPTION</th>
                                  <th className="ps-2">AMOUNT</th>
                                  <th className="ps-2"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {otherCostList.map((row, index1) => (
                                  <tr
                                    key={row.id}
                                    style={{
                                      height: "60px",
                                      position: "relative",
                                      overflow: "visible",
                                    }}
                                  >
                                    <td
                                      className="px-2 py-1"
                                      style={{
                                        position: "relative",
                                        overflow: "visible",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        className="form-control rounded-3 vendor-form-input"
                                        id={`description` + index1}
                                        placeholder="Enter here"
                                        value={row.description}
                                        onChange={(e) => {
                                          const tempOtherCostList = [
                                            ...otherCostList,
                                          ];
                                          tempOtherCostList[index1][
                                            "description"
                                          ] = e.target.value;
                                          setOtherCostList(tempOtherCostList);
                                        }}
                                        style={{
                                          borderColor:
                                            getErrorMsg(
                                              index1,
                                              "description"
                                            ) !== ""
                                              ? "red"
                                              : "#EBEBEB",
                                        }}
                                      />{" "}
                                      <span className="fs-12 fw-400 cardTextRed">
                                        {getErrorMsg(index1, "description")}
                                      </span>
                                    </td>

                                    <td className="px-2 py-1">
                                      <input
                                        type="text"
                                        className="form-control rounded-3 vendor-form-input"
                                        id={`cost` + index1}
                                        placeholder="Enter here"
                                        value={row.cost}
                                        onChange={(e) => {
                                          const tempOtherCostList = [
                                            ...otherCostList,
                                          ];
                                          tempOtherCostList[index1]["cost"] =
                                            e.target.value
                                              .replace(/[^0-9.]/g, "")
                                              .replace(/(\..*)\./g, "$1");

                                          setOtherCostList(tempOtherCostList);
                                        }}
                                        style={{
                                          borderColor:
                                            getErrorMsg(index1, "cost") !== ""
                                              ? "red"
                                              : "#EBEBEB",
                                        }}
                                      />{" "}
                                      <span className="fs-12 fw-400 cardTextRed">
                                        {getErrorMsg(index1, "cost")}
                                      </span>
                                    </td>

                                    <td>
                                      <div
                                        style={{
                                          cursor: "pointer",
                                          marginTop: "14px",
                                        }}
                                        onClick={() => {
                                          if (
                                            row.id !== null &&
                                            row.id !== ""
                                          ) {
                                            setRemovedOtherCostList([
                                              ...removedOtherCostList,
                                              row.id,
                                            ]);
                                          }
                                          const tempOtherCostList = [
                                            ...otherCostList,
                                          ];
                                          tempOtherCostList.splice(index1, 1);
                                          setOtherCostList(tempOtherCostList);
                                        }}
                                        className="mx-2 ps-2 d-flex align-items-center justify-content-center "
                                      >
                                        <img src={deleteIcon} alt="delete" />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-xl-12 mt-2">
                          <Button
                            className={`cursor-pointer border-0 rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                            onClick={() => {
                              setOtherCostList([
                                ...otherCostList,
                                {
                                  id: "",
                                  description: "",
                                  cost: "",
                                },
                              ]);
                            }}
                            style={{
                              minWidth: "100px",
                              background: "#E6E4FF",
                              color: "#212129",
                              fontWeight: "600",
                              fontSize: "13px",
                            }}
                          >
                            Add other cost
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="m-2 bg-white rounded-4 p-3">
              <div className="row">
                <div className="col-xl-12">
                  <p className="fs-18 fw-600 " style={{ textAlign: "left" }}>
                    Attachments{" "}
                  </p>
                </div>
                <div className="row pt-0">
                  {attachmentURLList.length > 0 && (
                    <div
                      style={{
                        marginTop: "16px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "start",
                        gap: "16px",
                      }}
                    >
                      {attachmentURLList.map((item, attachIndex) => (
                        <div
                          style={{
                            width: "312px",
                            height: "62px",
                            borderRadius: "12px",
                            padding: "12px 16px 12px 16px",
                            backgroundColor: "#F7F7F7",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={attachment}
                            style={{ width: "37px", height: "36px" }}
                          />
                          <div
                            style={{
                              width: "240px",
                              marginLeft: "8px",
                              marginTop: "4px",
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "500px",
                                fontSize: "13px",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "2px",
                              }}
                            >
                              {item.name}
                            </span>
                            <br />
                            <p
                              style={{
                                fontWeight: "400px",
                                fontSize: "12px",
                                lineHeight: "16.2px",
                                color: "#8790A1",
                              }}
                            >
                              {item.size}
                            </p>
                          </div>

                          {item.url && (
                            <div
                              onClick={() => {
                                downloadFile(
                                  item.url,
                                  item.url.split("/").pop()
                                );
                              }}
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "100px",
                              }}
                            >
                              <img
                                src={download}
                                style={{
                                  width: "12.8px",
                                  height: "12px",
                                  top: "10px",
                                  left: "9.6px",
                                }}
                              />
                            </div>
                          )}

                          <div
                            style={{
                              position: "relative",
                              width: "32px",
                              height: "32px",
                              borderRadius: "100px",
                              marginLeft: "4px",
                            }}
                          >
                            <img
                              src={closeAttachment}
                              style={{
                                width: "12.8px",
                                height: "12px",
                                top: "10px",
                                left: "9.6px",
                              }}
                              alt="remove"
                              onClick={() => {
                                /* removeAttachment(item.id); */
                                setRemovedAttachmentList([
                                  ...removedAttachmentList,
                                  item.id,
                                ]);
                                setAttachmentURLList(
                                  attachmentURLList.filter(
                                    (_, i) => i !== attachIndex
                                  )
                                );
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {attachmentList.length > 0 && (
                    <div
                      style={{
                        marginTop: "16px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "start",
                        gap: "16px",
                      }}
                    >
                      {attachmentList.map((item, attachIndex) => (
                        <div
                          style={{
                            width: "312px",
                            height: "62px",
                            borderRadius: "12px",
                            padding: "12px 16px 12px 16px",
                            backgroundColor: "#F7F7F7",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={attachment}
                            style={{ width: "37px", height: "36px" }}
                          />
                          <div
                            style={{
                              width: "210px",
                              marginLeft: "8px",
                              marginTop: "4px",
                            }}
                          >
                            <div
                              style={{
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                fontWeight: "500px",
                                fontSize: "13px",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "2px",
                              }}
                            >
                              {item.name}
                            </div>
                            <p
                              style={{
                                fontWeight: "400px",
                                fontSize: "12px",
                                lineHeight: "16.2px",
                                color: "#8790A1",
                              }}
                            >
                              {item.size}
                            </p>
                          </div>

                          <div
                            style={{
                              position: "relative",
                              width: "32px",
                              height: "32px",
                              borderRadius: "100px",
                              marginLeft: "4px",
                            }}
                          >
                            <img
                              src={closeAttachment}
                              style={{
                                width: "12.8px",
                                height: "12px",
                                top: "10px",
                                left: "9.6px",
                              }}
                              onClick={() => {
                                setAttachmentList(
                                  attachmentList.filter(
                                    (_, i) => i !== attachIndex
                                  )
                                );
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  <div
                    className="col-12 p-2 d-flex flex-column rounded-4 align-items-center justify-content-center m-2"
                    style={{
                      border: "1px dashed #9FBCFD",
                      background: "#FAFAFA",
                    }}
                  >
                    <div
                      onClick={handleInputFile}
                      onDrop={handleDrop}
                      onDragOver={(e) => e.preventDefault()}
                      onDragEnter={() => setDragging(true)}
                      onDragLeave={() => setDragging(false)}
                      className="d-flex flex-column justify-content-center align-items-center gap-3"
                    >
                      {image ? (
                        <img
                          src={image}
                          alt="Uploaded Vehicle"
                          className="rounded"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img
                          src={upload}
                          alt="Upload Icon"
                          style={{ width: "60px", height: "60px" }}
                        />
                      )}
                      <p className="fw-semibold m-0 p-0">Upload document</p>
                      <p className="m-0 fs-14 text-muted-grey p-0">
                        Add a document here by dragging & dropping, or choose
                        files manually.
                      </p>
                    </div>

                    {image ? (
                      <Button
                        className="mt-1 bg-danger border-0 text-white rounded-pill px-4 py-2 fw-500"
                        onClick={handleDelete}
                      >
                        Delete
                      </Button>
                    ) : (
                      <Button
                        className="cursor-pointer mt-1 border-0  rounded-pill text-white  px-4 py-2 fw-500"
                        style={{ background: "#4F46E5" }}
                        onClick={handleInputFile}
                      >
                        Select a file
                      </Button>
                    )}

                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      className="d-none"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
